import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {HttpClient} from '@angular/common/http';
import {SessionStorageService} from './session-storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EtapaAtual, Proposta } from '../models/coleta';
import { ResponseBody } from '../models/response-body.model';
import { Recaptcha } from '../models/recaptcha';

@Injectable({
  providedIn: 'root'
})
export class ReRecaptchaSmileGoService extends BaseApiService {


  constructor(private httpClient: HttpClient, private localStorageService: SessionStorageService) {
    super('whitelabel/recaptcha', localStorageService);
  }

  verify(token: Recaptcha): Observable<any> {
    return this.httpClient
      .post<any>(this.baseUrl, token)
  }

  

}
